export default __webpack_public_path__ + "66f7f39da097796da460dd3960b6249a.svg";